import React from 'react';
import { Container } from '@mui/material';
import { useFormRenderFromContext } from '../../application';

export const BankAccountPage = () => {
  const { BankAccountForm } = useFormRenderFromContext();

  return (
    <Container
      maxWidth={false}
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        mb: 3,
        mx: 0,
        pt: { xs: 4, md: 5 },
        px: { xs: 2, md: 5, lg: 8 },
      }}
    >
      <BankAccountForm />
    </Container>
  );
};
